<template>
  <div class="login-box">
    <van-dialog
      v-model="showLogin"
      :closeOnClickOverlay="true"
      :showConfirmButton="false"
      ref="dialog"
    >
       <div>
        <div class="text-center" style="padding:1.5rem 0;">
          <div v-if="!isWeixin">
            <div class="qrcode-container">
              <van-image :src="qrcodeUrl"></van-image>
              <div v-show="qrcodeTimeout" class="qrcode-exp-tips" @click="refresh">
                <van-icon name="replay" />
                <div>已过期，点击刷新</div>
              </div>
            </div>
            <div class="qrcode-msg">{{ qrcodeMsg }}</div>
            <div style="color:#777;">请使用微信扫码登录</div>
          </div>
          <div v-else class="weixin-container">
            <van-button type="primary" @click="clickLogin"><van-icon name="wechat" /> 微信登录</van-button>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
import { removeClass } from '@/utils/utils';
import qrcode from 'qrcode';
export default {
  mixins: [siteMixin],
  components: {},
  props: {
    backRoute: Object
  },
  data() {
    return {
      showLogin: false,
      websocket: null,
      timerWebsocket: null,
      qrcodeUrl: null,
      qrcodeMsg: '',
      timer: null,
      qrcodeTimeout: false,
    }
  },
  computed: {
    ...mapState(['c_token'])
  },
  watch: {
    c_token() {
      if (this.websocket && this.websocket.readyState === 1) {
        let params = { token: this.$store.state.c_token };
        this.websocket.send(JSON.stringify(params));
      }
    },
    showLogin(val) {
      if (val) {
        this.login4Weixin();
      } else {
        /*** fixed 有时候关闭登录框后，body的class不会清除，调用下边句强制清除 ***/
        removeClass(document.querySelector('body'), 'van-overflow-hidden');
      }
    }
  },
  mounted () {
    
  },
  methods: {
    show(flag) {
      this.showLogin = flag ? true : false;
    },
    // 使用微信浏览器登录或生成登录二维码
    login4Weixin() {
      if (!this.isWeixin) {
        this.Toast.loading('登录二维码生成中...');
        // 获取token
        this.$store.dispatch(types.JY_TOKEN_GET, () => {
          // 连接websocket
          this.connWebscoket(() => {
            // 生成二维码
            this.weixinQrcode();
          });
        });
      }
    },
    // 刷新二维码
    refresh() {
      this.qrcodeTimeout = false;
      this.qrcodeMsg = '';
      this.weixinQrcode();
    },
    // 从后端取得token，并生成二维码
    weixinQrcode() {
      this.qrcodeTimeout = false;
      let device = this.isMobile ? 'mobile' : 'pc';
      let _url = `${this.myPath}site/login/getQrUrl?token=${this.c_token}&device=${device}&time=${Date.now()}`;
      this.qrcodeUrl = '';
      this.Toast.loading('正在生成二维码...');

      qrcode.toDataURL(_url, {margin:1, width:150, height:150, color:{light:'#FFFFFFCC'}})
        .then(url => {
          this.qrcodeUrl = url;
          this.Toast.clear();
        })
        .catch((err) => {
          this.Toast.clear();
          setTimeout(() => {
            this.Toast.fail('二维码生成失败！');
            console.log(err)
          }, 50);
        });

      // 倒计时
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.qrcodeTimeout = true;
      }, 1000 * 180);
    },
    logout() {
      this.$store.dispatch(types.JY_LOGOUT, () => {
        this.$router.push('/');
      });
    },
    // 微信浏览器登录
    clickLogin() {
      // 记录登录后回调的url
      let backRoute = this.backRoute || null;
      if (backRoute) {
        backRoute = {path: backRoute.path, params: backRoute.params, query: backRoute.query};
      } else {
        backRoute = {path: this.$route.path, params: this.$route.params, query: this.$route.query};
      }
      try {
        this.$store.commit(types.JY_BACKURL, { backRoute: backRoute });
        // 跳转到微信登录
        let url = `${this.myHost}weixin`; // 登录后跳转url
        top.location.href = `${this.rootPath}site/login/loginOpen?url=${encodeURI(url)}`;
        // top.location.href = this.rootPath +'site/login/loginOpen?c_token='+ this.$store.state.c_token;
      } catch (error) {
        console.log(error)
      }
    },
    login4Token() {
      // console.log(this.token)
      if (this.token) {
        this.$store.dispatch(types.JY_LOGIN_TOKEN, {
          newtoken: this.token,
          callback: (flag) => {
            console.log(flag, this.backRoute)
            if (flag) {
              let backRoute = this.backRoute;
              if (backRoute) {
                this.$store.commit(types.JY_BACKURL_CLEAR);
                this.$router.push(backRoute);
              }
            }
          }
        });
      }
    },
    connWebscoket(callback) {
      // websocket
      if (!this.websocket || this.websocket.readyState > 1) {
        this.websocket = new WebSocket(this.wsHost +"api/websocket/login.ws");
      }
      if (this.websocket) {
        if (this.timerWebsocket) {
          clearInterval(this.timerWebsocket);
          this.timerWebsocket = null;
        }
        this.doWebscoket();
        if (callback) {
          callback();
        }
      }
    },
    doWebscoket() {
      //连接成功建立的回调方法
      this.websocket.onopen = () => {
        // 发送token到服务器
        if (this.websocket && this.websocket.readyState === 1) {
          let params = { token: this.c_token };
          this.websocket.send(JSON.stringify(params));
        }
      };
      // websocket - onmessage
      this.websocket.onmessage = (event) => {
        // console.log(event);
        let json = JSON.parse(event.data);
        // console.log(json)
        this.qrcodeMsg = '';
        if (json.nickname) {
          this.$store.dispatch(types.JY_LOGIN_MEMBER, {token: json.token, callback: (flag/*, msg*/) => {
              if (flag) {
                this.$emit('login');
                this.websocket && this.websocket.close();
                this.websocket = null;
              }
            }
          });
        } else if (json.message) {
          this.qrcodeMsg = json.message;
        }
      };
      //连接发生错误的回调方法
      this.websocket.onerror = () => {
        console.log("WebSocket连接发生错误");
        this.websocket = null;
        this.timerWebsocket && (clearInterval(this.timerWebsocket));
        this.timerWebsocket = setInterval(() => {
          this.connWebscoket();
        }, 1000);
      };
    },
  }
}
</script>
<style lang="less" scoped>
.login-box /deep/ {
  .text-center{text-align:center;}
  .d-flex{.flex-column();}
  .van-dialog {
    top:50%;
    transform:translate(-50%, -50%);
  }
}
.qrcode-container {
  position: relative;
  margin:0 auto;
  width:150px;
  height:150px;
  .van-image {
    width: 100%;
    height: 100%;
  }
  .qrcode-exp-tips {
    position: absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color:#fff;
    background-color:rgba(0,0,0,.75);
    cursor: pointer;
  }
  .van-icon {
    font-size: 2.6rem;
  }
}
</style>